import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding-top":"40px","min-height":"80vh"} }
const _hoisted_2 = { class: "container mar_b" }
const _hoisted_3 = {
  style: {},
  class: "user_banner"
}
const _hoisted_4 = {
  style: {},
  class: "left"
}
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text" }

import { reactive } from "vue";
import Introduction from "./introduction/index.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const router = useRouter()

const data = reactive({
    userInfo: {} as any,
})
data.userInfo = store.state.userInfomation
// data.userInfo = {
//     "userName": "王宝山",
//     "certNo": "410928196304039633",
//     "userType": "1",
//     "userMobile": "17788100338",
//     "corpType": "C01",
//     "certificateSno": "91410223MA40GEQL7N",
//     "corpName": "尉氏县瑞隆置业有限公司",
// }



return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "line" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "img" }, [
              _createElementVNode("img", { src: "https://www.kfzwfw.gov.cn/img/touxiang.4b56eb84.png" })
            ], -1)),
            _createElementVNode("div", _hoisted_5, _toDisplayString(data.userInfo.userName), 1),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text" }, "已通过实名认证", -1)),
            _createElementVNode("div", _hoisted_6, "手机号码：" + _toDisplayString(data.userInfo.userMobile), 1),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text" }, [
              _createElementVNode("a", {
                class: "btn",
                href: "https://login.hnzwfw.gov.cn/tacs-uc/login/index",
                target: "_blank"
              }, "修改信息")
            ], -1))
          ])
        ]),
        _createVNode(Introduction)
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})